type BridgeOptions={
  productType:number;
  orgId:()=>number;
  enabled:()=>boolean;
  origin:()=>string;
  create:(orgId:number,productType:number)=>Promise<any>;
  read:(pollToken:string)=>Promise<any>;
  onUrl:(url:string)=>void;
  onError:(message:string)=>void;
  now?:()=>number;
}

// 上传和读取分别使用短期随机凭证，二维码不暴露客户身份及读取凭证。
export const createImageSearchBridge=(options:BridgeOptions)=>{
  let session:any=null,sessionOrg=0,busy=false,disposed=false,retryAt=0,generation=0
  const now=options.now || Date.now
  const expiry=(value:any)=>typeof value==='number'?value:Date.parse(value)
  const poll=async():Promise<any>=>{
    if(disposed)return {data:null}
    if(!options.enabled()){
      generation++;session=null;options.onUrl('');options.onError('')
      return {data:null}
    }
    if(busy || now()<retryAt)return {data:null}
    busy=true
    const run=generation,orgId=Number(options.orgId())
    try{
      if(!session || sessionOrg!==orgId || expiry(session.expiresAt)<=now()+15000){
        options.onUrl('')
        const result=await options.create(orgId,options.productType)
        if(disposed || generation!==run || orgId!==Number(options.orgId()))return {data:null}
        if(!options.enabled()){session=null;options.onUrl('');return {data:null}}
        if(!result?.data?.uploadToken || !result?.data?.pollToken || !Number.isFinite(expiry(result.data.expiresAt)))throw new Error('二维码暂时无法生成，请重试')
        session=result.data
        sessionOrg=orgId
        options.onUrl(`${options.origin()}/imageSearching?searchSession=${encodeURIComponent(session.uploadToken)}`)
        options.onError('')
      }
      const result=await options.read(session.pollToken)
      if(disposed || generation!==run || orgId!==Number(options.orgId()))return {data:null}
      if(!options.enabled()){session=null;options.onUrl('');return {data:null}}
      options.onError('')
      return result
    }catch(error){
      if(!disposed && generation===run){
        session=null
        retryAt=now()+10000
        options.onUrl('')
        options.onError(options.enabled()?'二维码暂时不可用，点击重试':'')
      }
      return {data:null}
    }finally{busy=false}
  }
  return {
    poll,
    retry(){generation++;session=null;retryAt=0;options.onUrl('');return poll()},
    dispose(){disposed=true;generation++;session=null;options.onUrl('')}
  }
}
